<template>
  <div ref="refMainContainer">
    <!-- <vue-draggable-resizable class="ma-0 pa-0" :parent="true" :lock-aspect-ratio="true" :w="400" h="auto" :x="helpMenuLocationX" :y="helpMenuLocationY" :min-width="200" :z="99999" v-if="helpVisible && routerCurrentPath && routerCurrentPath.meta && routerCurrentPath.meta.video_file && userSettings.showFlyingHelp" :style="'border: 2px solid ' + Colors.ActiveItemBackground">
      <div class="ma-0" style="position: relative; width: 100%; max-height: 100%; padding-top: 20px; padding-bottom: 20px; padding-left: 40px; padding-right: 40px;">
        <v-btn class="ma-0 pa-0" color="red" text icon outlined small style="background: white; position: absolute; top: 2px; right: 2px;" @click="userSettings.showFlyingHelp = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <video class="ma-0 pa-0" :ref="'refPlayer'" width="100%" height="auto" controls :disablePictureInPicture="true">
          <source :src="routerCurrentPath.meta.video_file" type="video/mp4" />
        </video>
      </div>
    </vue-draggable-resizable> -->
    <v-app-bar v-if="isOnMobile" app dense clipped-left class="ma-0 pa-0 elevation-5" :style="`background-color: ${Colors.MenuColor}`">
      <div :style="'background: ' + Colors.ActiveItemBackground">
        <v-app-bar-nav-icon :color="Colors.IconColor" class="hidden-md-and-up" @click.stop="mobileMenu = !mobileMenu"></v-app-bar-nav-icon>
      </div>
      <v-spacer></v-spacer>
      <div style="cursor: pointer" @click="mobileMenu = !mobileMenu">
        <v-icon class="mx-2" :color="Colors.IconColor" size="20">{{ routes[currentTab].meta.icon }} </v-icon>
        <span>{{ routes[currentTab].title }}</span>
      </div>

      <v-spacer></v-spacer>
      <v-btn v-if="TR.Locale == Translation.bg.Locale && routerCurrentPath.name != 'help'" :color="Colors.TransparentColor" rounded style="z-index: 999; position: absolute; left: auto; right: 10px; top: 1px; bottom: auto" icon @click.native="openHelpMenu(routerCurrentPath.name)">
        <v-icon :color="Colors.IconColor">mdi-help-circle-outline</v-icon>
      </v-btn>
      <!-- <v-btn style="width: 100%" height="100%" text @click="openTremolSite()" :small="isOnMobile" :style="(isInDarkMode ? 'color: white;' : 'color: black;') + 'width: ' + $vuetify.application.left + 'px;' + (isOnMobile ? ' position: absolute; right: 10px;' : '')">
        <v-avatar size="40px" tile>
          <img :src="tremolLogo" />
        </v-avatar>
        <span style="font-size: 15px" class="ml-1">{{ isOnMobile ? "" : "Тремол ООД © 2020" }}</span>
      </v-btn>-->
      <v-divider v-if="!isOnMobile" vertical style="margin-left: -1px"></v-divider>
      <v-row v-if="!isOnMobile" class="ma-0 pa-0" justify="center">
        <v-icon left>{{ routerCurrentPath.meta.icon }}</v-icon>
        <span class="title">{{ routerCurrentPath.title }}</span>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer app clipped v-model="mobileMenu" :temporary="isOnMobile" :permanent="!isOnMobile" class="customscroll elevation-2" :width="isOnMobile ? 'auto' : '300'" :style="`background-color: ${Colors.MenuColor}; height: calc(100% - 0px);`">
      <t-background v-if="!isInDarkMode" :opacityprop="'0.4'" style="z-index: -1"></t-background>
      <div class="box-container">
        <v-list shaped class="row-header mx-2 px-0" v-if="getUser">
          <v-list-item tabindex="-1">
            <v-row class="ma-0 pa-0" style="cursor: pointer" @click="selectTab(routes.find((r) => r.path == '/' + TR.Locale + '/settings'))">
              <v-list-item-content>
                <v-list-item-title>
                  <v-tooltip :disabled="hideTooltips" bottom style="z-index: 10">
                    <template v-slot:activator="{ on }">
                      <div v-if="getUser && getUser.isDistributor" v-on="on" fluid class="subtitle-1" :style="`position: relative; width: 100%; text-align: center; color: ${Colors.MenuTextColor}`">{{ TR.DistributorProfile }}</div>
                    </template>
                    {{ TR.ProfileSettings }}
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-title>
                  <span class="subtitle-1" :style="`color: ${Colors.MenuTextColor}`">{{ getUsername().padRight(25).substring(0, 25) }}</span>
                </v-list-item-title>
                <v-tooltip v-if="getUser && getUserType == UserTypes.Observer" :disabled="hideTooltips" bottom style="z-index: 10">
                  <template v-slot:activator="{ on }">
                    <v-list-item-title v-on="on" @click.stop="pickFirm()">
                      <span :style="`color: ${Colors.MenuTextColor}`">{{ getChosenFirm() }}</span>
                    </v-list-item-title>
                  </template>
                  {{ TR.ChooseFirm }}
                </v-tooltip>

                <v-tooltip v-else-if="getUser && getUserType == UserTypes.Owner && TR.Locale == Translation.bg.Locale" :disabled="hideTooltips" bottom style="z-index: 10">
                  <template v-slot:activator="{ on }">
                    <v-list-item-title v-on="on" @click.stop="selectTab(routes.find((r) => r.path == '/' + TR.Locale + '/balanceLog'))" class="subtitle-2">
                      <span :style="`color: ${Colors.MenuTextColor};`">{{ TR.CurrentBalance + ":" }}</span>
                      <span style="float: right" class="text-right" :class="getUser.balance <= 0 ? 'error--text' : 'success--text'">{{ getUser.balance.toFixed(2) + " " + TR.MoneyAbbreviation }}</span>
                    </v-list-item-title>
                  </template>
                  {{ TR.ShowBalanceLog }}
                </v-tooltip>

                <template v-else-if="getUser && getUserType == UserTypes.Owner && TR.Locale == 'ro'">
                  <v-list-item-title v-if="getCurrentTechnician()" @click.stop="pickTechnician(getUser)">
                    <span class="subtitle-1" :style="`color: ${Colors.MenuTextColor};`">{{ getCurrentTechnician() }}</span>
                  </v-list-item-title>

                  <div>
                    <span :style="`color: ${Colors.MenuTextColor};`">{{ TR.DevsCount + ": " }}</span>
                    <span style="float: right" class="text-right success--text">{{ getDevsCount }}</span>
                  </div>
                  <div v-if="getUser.payedTo">
                    <span :style="`color: ${Colors.MenuTextColor};`">{{ TR.PayedTo + ":" }}</span>
                    <span style="float: right" class="text-right" :class="getUser.payedTo.addDays(-15).getTime() <= new Date().getTime() ? 'error--text' : 'success--text'">{{ getUser.payedTo.toTremolFpStringShort() }}</span>
                  </div>

                  <!-- <div v-if="getUser.pricePerDev">
                    <span :style="`color: ${Colors.MenuTextColor};`">{{ TR.PriceForMonth + ": " }}</span>
                    <span style="float: right" class="text-right success--text">{{ getUser.pricePerDev.toFixed(2) + "€" }}</span>
                  </div> -->
                </template>

                <v-tooltip v-if="getUser && getUser.inTrial && getUserType != UserTypes.Distributor" :disabled="hideTooltips" bottom style="z-index: 10">
                  <template v-slot:activator="{ on }">
                    <v-list-item-title v-on="on" class="subtitle-2 mt-3">
                      <span :style="`color: ${Colors.MenuTextColor};`">
                        {{ TR.RemainingTrialDays + ": " }}
                      </span>
                      <span style="float: right" class="text-right">
                        <b class="success--text">{{ getTrialDays() }}</b>
                      </span>
                    </v-list-item-title>
                  </template>
                  {{ TR.DateAccountCreated + ": " + getUser.dateAccountCreated.toTremolFpString() }}
                </v-tooltip>
                <template v-else-if="getUser && getUserType == UserTypes.Distributor">
                  <v-list-item-title class="subtitle-2">
                    <span :style="`color: ${Colors.MenuTextColor};`">{{ TR.EIK + ": " + getUser.eik.replace("DA", "") }}</span>
                  </v-list-item-title>

                  <v-tooltip :disabled="isOnMobile" bottom style="z-index: 10">
                    <template v-slot:activator="{ on }">
                      <v-list-item-title v-on="on" class="mt-2 subtitle-2">
                        <span :style="`color: ${Colors.MenuTextColor};`">{{ TR.BonusAccumulated + ":" }}</span>
                        <span style="float: right" class="text-right success--text">{{ getUser.distrPmtBonusAccumulated ? getUser.distrPmtBonusAccumulated.toFixed(2) + " " + TR.MoneyAbbreviation : "0 " + TR.MoneyAbbreviation }}</span>
                      </v-list-item-title>
                    </template>
                    {{ TR.BonusUnused }}
                  </v-tooltip>
                </template>
                <!-- <v-list-item-subtitle>ЕИK: {{ getUser.eik }}</v-list-item-subtitle> -->
              </v-list-item-content>
            </v-row>
          </v-list-item>
        </v-list>
        <v-divider class="row-header"></v-divider>
        <v-list shaped class="row-content font-weight-regular ml-2 mr-0 px-0">
          <template v-for="(gr, index) in getGroups">
            <template v-if="gr.isSingle">
              <v-tooltip v-for="route in getRoutesByGroupName(gr.name)" :key="route.name" :disabled="hideTooltips" right style="z-index: 10">
                <template v-slot:activator="{ on }">
                  <v-list-item v-on="on" class="mr-2" link v-on:click.native="selectTab(route)" :style="routerCurrentPath.name == route.name ? 'background: ' + Colors.ActiveItemBackground : ''">
                    <v-icon :color="Colors.IconColor" class="mr-3">{{ route.meta.icon }}</v-icon>
                    <v-badge offset-x="20" offset-y="22" v-if="route.meta.events" color="red" overlap :bordered="!isInDarkMode">
                      <template v-slot:badge>
                        <span>{{ route.meta.events }}</span>
                      </template>
                    </v-badge>
                    <v-list-item-title>
                      <span :style="`color: ${Colors.MenuTextColor}`">{{ route.title }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </template>
                {{ route.meta.menu_description }}
              </v-tooltip>
            </template>
            <template v-else>
              <v-list-group :key="index" color="base" class="mr-2" v-model="expanded_groups[index]">
                <template v-slot:activator>
                  <v-icon :color="Colors.IconColor" class="mr-3">{{ gr.icon }}</v-icon>
                  <v-badge offset-x="20" offset-y="22" v-if="expanded_groups[index] == false && gr.events" color="red" overlap :bordered="!isInDarkMode">
                    <template v-slot:badge>
                      <span>{{ gr.events }}</span>
                    </template>
                  </v-badge>
                  <v-list-item-title>
                    <span :style="`color: ${Colors.MenuTextColor}`">{{ gr.name }}</span>
                  </v-list-item-title>
                </template>
                <div class="box-container-horizontal">
                  <v-divider vertical class="row-header ma-0 pa-0 ml-6 mr-2"></v-divider>
                  <div class="row-content">
                    <v-tooltip v-for="(route, i) in getRoutesByGroupName(gr.name)" :key="i" :disabled="hideTooltips" right>
                      <template v-slot:activator="{ on }">
                        <v-list-item class="ml-0 pl-2" link v-on="on" v-on:click.native="selectTab(route)" :style="routerCurrentPath.name == route.name ? 'background: ' + Colors.ActiveItemBackground : ''">
                          <v-icon :color="Colors.IconColor" class="mr-3">{{ route.meta.icon }}</v-icon>
                          <v-badge offset-x="20" offset-y="22" v-if="route.meta.events" color="red" overlap :bordered="!isInDarkMode">
                            <template v-slot:badge>
                              <span>{{ route.meta.events }}</span>
                            </template>
                          </v-badge>
                          <v-list-item-title>
                            <span :style="`color: ${Colors.MenuTextColor}`">{{ route.title }}</span>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      {{ route.meta.menu_description }}
                    </v-tooltip>
                  </div>
                </div>
              </v-list-group>
            </template>
          </template>
        </v-list>
        <v-divider class="row-header"></v-divider>
        <v-btn class="my-2 row-header" text block color="error" dark @click="logout(TR.Locale != Translation.bg.Locale)">
          <span class="ml-1">{{ TR.Logout }}</span>
          <v-icon small class="ml-1">mdi-logout</v-icon>
        </v-btn>
        <!-- <v-footer app persistent v-if="!isOnMobile">
        <span>Tremol</span>
        <v-spacer />
        <span>&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>-->
      </div>
    </v-navigation-drawer>
    <v-main app>
      <div class="maincontainer ma-0 pa-0" :style="`height: calc(100% - ${headerFooterHeight}px); width: calc(100% - ${menuWidth}px);`">
        <t-background v-if="!isInDarkMode" reversed :opacityprop="'0.5'" style="z-index: -1; overflow: hidden"></t-background>
        <v-container fill-height fluid class="ma-0 pa-0">
          <transition v-if="$route.fullPath">
            <keep-alive>
              <router-view :key="$route.fullPath"></router-view>
            </keep-alive>
          </transition>
          <v-btn v-if="!isOnMobile && TR.Locale == Translation.bg.Locale && routerCurrentPath.name != 'help'" :color="Colors.TransparentColor" rounded style="z-index: 999; position: absolute; left: auto; right: 1px; top: 1px; bottom: auto" icon @click.native="openHelpMenu(routerCurrentPath.name)">
            <v-icon size="26" :color="Colors.IconColor">mdi-help-circle-outline</v-icon>
          </v-btn>
        </v-container>
      </div>
      <div></div>
    </v-main>
  </div>
</template>

<script>
import Vue from "vue";
import bus, { TR } from "../main";
import DataManager from "../js/DataManager";
import router from "../router";
import Translation from "../js/Translation";
// import Notifications from "./Controls/Notifications";
//import HTTPSender from "../js/HTTPSender";

export default {
  // props: ["userprop"],
  components: {
    // Notifications,
  },
  data() {
    return {
      TR: TR,
      Translation: Translation,
      helpVisible: false,
      helpMenuLocationX: 0,
      helpMenuLocationY: 0,
      expanded_groups: [],
      UserTypes: DataManager.UserTypes,
      //barColor: "rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)",
      //barImage: require("../assets/img/main/Tremol_building.jpg"),
      tremolLogo: require("@/assets/img/main/darkLogo.png"),
      mobileMenu: false,
      currentTab: 0,
      // user: this.userprop,
      user: null,
      isInMainModule: false,
      clientFirms: [],
      router: router,
      devs: [],
    };
  },
  methods: {
    getUsername() {
      return this.getUser.firstName ? this.getUser.firstName + " " + this.getUser.lastName : this.getUser.userName;
    },
    getTrialDays() {
      var diffTime = Math.abs(this.user.dateAccountCreated.addDays(60) - new Date());
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    openHelpMenu(name) {
      const nm = name;
      router
        .push({ path: "/" + TR.Locale + "/help" })
        .catch(() => {})
        .then(() => {
          bus.$emit(bus.EVENT_Help_Needed, nm);
        });
    },
    closeChangePassDlg() {
      this.showChangePass = false;
    },
    closeInvoiceDataDlg() {
      this.showInvoiceData = false;
    },

    //refreshData() {
    //   this.blocked_devices = [];
    //   this.blocked_devices = DataManager.getData(DataManager.DataType.devices, true);
    //   if (!this.blocked_devices) {
    //     this.blocked_devices = [];
    //   }
    //   if (this.blocked_devices.length > 0) {
    //     this.blocked_devices = this.blocked_devices.filter((d) => d.IsBlocked);
    //   }
    //   this.incoming_messages = [];
    //   this.incoming_messages = DataManager.getData(DataManager.DataType.messages, true);
    //   if (!this.incoming_messages) {
    //     this.incoming_messages = [];
    //   }
    //   if (this.incoming_messages.length > 0) {
    //     this.incoming_messages = this.incoming_messages.filter((d) => d.seen == false);
    //   }
    //   const vis = this.blocked_devices.length + this.incoming_messages.length > 0;
    //   this.setBannerVisible(vis);
    // },
    onItemClick(event, item) {
      if (event) {
        this.selected = item;
      }
    },
    goToProgramModule() {
      //TODO !!
    },
    getRoutesByGroupName(name) {
      return this.routes.filter((r) => r.meta.group == name && DataManager.userHasAccess(r.meta.for_user));
    },
    selectTab(route) {
      if (!route) {
        return;
      }
      if (this.routes.indexOf(route) == -1) {
        route = this.routes.find((f) => f.title == route.title);
      }
      if (!route) {
        return;
      }
      if (route.path != router.currentRoute.path) {
        router.push({ path: route.path }).catch(() => {});
      }
      var foundGroupIdx = this.getGroups.findIndex((g) => g.name == route.meta.group && !g.isSingle);
      if (foundGroupIdx !== -1) {
        this.expanded_groups[foundGroupIdx] = true;
      }
      this.currentTab = this.routes.indexOf(route);
      this.mobileMenu = false;

      this.$nextTick(() => {
        this.helpMenuLocationX = this.menuWidth + this.mainContainerWidth - 403;
        this.helpMenuLocationY = 3;
        this.$nextTick(() => {
          if (this.user && this.userSettings.showFlyingHelp && this.$refs["refPlayer"]) {
            this.$refs["refPlayer"].play();
          }
        });
      });
    },
    getCurrentTechnician() {
      return DataManager.currentTechnician ? DataManager.currentTechnician.n : "";
    },
    getChosenFirm() {
      return DataManager.currentUser ? DataManager.currentUser.orgName : this.clientFirms.length == 0 ? "" : TR.CustomerNotChosen;
    },
  },
  computed: {
    routes() {
      return router.options.routes.find((f) => f.name == "MainContent").children.filter((c) => c.path.startsWith("/" + TR.Locale + "/"));
    },
    getGroups() {
      var groups = this.routes.filter((f) => DataManager.userHasAccess(f.meta.for_user)).map((r) => ({ name: r.meta.group, icon: r.meta.group_icon, isSingle: false, events: null }));
      groups.forEach((g) => {
        g.isSingle = this.routes.map((r) => r.meta.group).isElementUnique(g.name);
        g.events = this.routes
          .filter((r) => r.meta && r.meta.group && r.meta.group == g.name && r.meta.events)
          .map((r) => r.meta.events)
          .sum();
      });
      //console.log(groups);
      return groups.unique();
    },
    routerCurrentPath() {
      return router.currentRoute;
    },
    headerFooterHeight() {
      return this.$vuetify.application.top + this.$vuetify.application.footer + this.getBannerHeight;
    },

    returnTabs() {
      return this.tabs;
    },
    getUser() {
      if (this.user) {
        return this.user;
      } else {
        return null;
      }
    },
    getDevsCount() {
      return this.devs ? this.devs.length : "";
    },
    getDevsForTechCount() {
      return this.devs ? this.devs.filter((d) => d.IsForMe).length : "";
    },
    getUserType() {
      return DataManager.userType;
    },
  },
  watch: {},
  created() {
    this.getGroups.forEach(() => this.expanded_groups.push(false));
    bus.$on(bus.EVENT_AddTab_In_MainContent, (tabName) => {
      this.selectTab(this.routes.find((t) => t.name == tabName));
    });
    bus.$on(bus.EVENT_Device_selected_for_subscribtion, () => {
      this.selectTab(this.routes.find((t) => t.path == "/" + TR.Locale + "/devices"));
    });
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == DataManager.DataType.devices) {
        var rr = this.routes.find((r) => r.path == "/" + TR.Locale + "/events" && r.meta && r.meta.datatype == datatype);
        // Vue.set(rr.meta, "events", DataManager.getData(datatype, true).filter(d => (d.IsBlocked && d.LastReceipt.date.getTime() != d.IsBlockedChecked) || ((d.IsFMFull || d.IsFMNearFull) && !d.IsFMEventChecked)).length);
        this.devs = DataManager.getData(datatype, true);

        // var dvz = devz
        //   .filter((d) => !!d.LastReceipt && d.IsBlocked)
        //   .map((d) => {
        //     return { sn: d.sn, isBLocked: d.IsBlocked, lastRecDate: d.LastReceipt.dateReceived.getTime(), isBlockedCheckedDate: d.IsBlockedChecked };
        //   });
        //   console.log(dvz);
        Vue.set(rr.meta, "events", this.devs.filter((d) => d.IsBlocked && !!d.LastReceipt && d.LastReceipt.dateReceived.getTime() != d.IsBlockedChecked).length);
      } else if (datatype == DataManager.DataType.messages) {
        var route = this.routes.find((r) => r.path == "/" + TR.Locale + "/mailbox" && r.meta && r.meta.datatype == datatype);
        if (route) {
          Vue.set(route.meta, "events", DataManager.getData(datatype, true).filter((d) => !d.seen).length);
        }
      } else if (datatype == DataManager.DataType.user) {
        this.user = null;
        this.user = DataManager.getData(DataManager.DataType.user);
      }
      var totalEventsCount = this.routes
        .filter((r) => r.meta.events)
        .map((r) => r.meta.events)
        .sum();
      document.title = totalEventsCount > 0 ? "(" + totalEventsCount + ") Tremol Assistant" : "Tremol Assistant";
    });
    // bus.$on(bus.EVENT_Android_Swipe, swipe => {
    //   if (swipe == bus.AndroidSwipes.endright) {
    //     this.mobileMenu = false;
    //   } else if (swipe == bus.AndroidSwipes.endleft) {
    //     this.mobileMenu = true;
    //   }
    // });
  },
  mounted() {
    this.user = DataManager.getData(DataManager.DataType.user);
    bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.messages);
    // window.Notification.requestPermission()
    //   .then(function() {
    //      setInterval(() => {
    //         new Notification("Hi there KIFTAK!");
    //     }, 2000);
    //   }
    //   );

    this.$nextTick(() => {
      this.helpVisible = true;
    });
  },
  updated() {},
};
</script>

<style scoped>
.v-list-item >>> span {
  font-size: 14px;
}

.v-list-group >>> span {
  font-size: 14px;
}

.closeBtn:hover:before {
  background-color: transparent;
}

div >>> .v-toolbar__content {
  padding: 0;
}

div >>> .v-banner__wrapper {
  border: 5px solid yellow;
}

div >>> .tremol-logo-btn {
  justify-content: start;
}

.bordered-item {
  margin: auto;
  display: flex;
  width: 204px;
  height: 204px;
}

.v-menu {
  margin-top: 40px;
  contain: initial;
  overflow: visible;
}
.v-menu::before {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
</style>